import React from 'react';
import { 
    Modal, Form, Input, Select, Spin, Alert, Divider,
    Button
} from 'antd';
import { 
    LockOutlined, SaveOutlined
} from '@ant-design/icons';

const { Option } = Select;

const SpApiConfigurationModal = ({
    visible,
    editingAccount,
    selectedWorker,
    loading,
    workers,
    onSave,
    onCancel
}) => {
    const [form] = Form.useForm();

    // Reset form when visible changes or selection changes
    React.useEffect(() => {
        if (visible) {
            form.resetFields();
            
            if (selectedWorker) {
                form.setFieldsValue({
                    workerId: selectedWorker.id
                });
            }
        }
    }, [visible, selectedWorker, form]);

    const handleSave = async () => {
        try {
            const values = await form.validateFields();
            onSave(values);
        } catch (error) {
            console.error('SP API form validation failed:', error);
        }
    };

    return (
        <Modal
            title="Cấu hình SP API cho Worker"
            open={visible}
            confirmLoading={loading}
            onOk={handleSave}
            onCancel={onCancel}
            width={600}
            okText="Lưu lại"
            cancelText="Hủy"
            okButtonProps={{ 
                icon: <SaveOutlined />,
                loading: loading 
            }}
        >
            <Spin spinning={loading}>
                <Form 
                    form={form} 
                    layout="vertical" 
                    className="sp-api-form"
                >
                    <Form.Item
                        name="workerId"
                        label="Worker"
                        rules={[{ required: true, message: 'Vui lòng chọn worker' }]}
                    >
                        <Select 
                            placeholder="Chọn worker"
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) => 
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            disabled={selectedWorker !== null}
                        >
                            {workers.filter(w => w.status === 'online').map(worker => (
                                <Option key={worker.id} value={worker.id}>
                                    {worker.name} {worker.status === 'online' ? '(Online)' : '(Offline)'}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Alert
                        message="Thông tin SP API"
                        description="Các thông tin này sẽ được cung cấp bởi Amazon Selling Partner API. Chúng sẽ được lưu vào worker được chọn và cập nhật tự động mà không cần khởi động lại worker."
                        type="info"
                        showIcon
                        style={{ marginBottom: 16 }}
                    />

                    <Form.Item
                        name="clientId"
                        label={<span><LockOutlined /> Client ID</span>}
                        rules={[{ required: true, message: 'Vui lòng nhập Client ID' }]}
                    >
                        <Input.Password placeholder="Nhập Client ID" />
                    </Form.Item>

                    <Form.Item
                        name="clientSecret"
                        label={<span><LockOutlined /> Client Secret</span>}
                        rules={[{ required: true, message: 'Vui lòng nhập Client Secret' }]}
                    >
                        <Input.Password placeholder="Nhập Client Secret" />
                    </Form.Item>
                    
                    <Form.Item
                        name="refreshToken"
                        label={<span><LockOutlined /> Refresh Token</span>}
                        rules={[{ required: true, message: 'Vui lòng nhập Refresh Token' }]}
                    >
                        <Input.Password placeholder="Nhập Refresh Token" />
                    </Form.Item>

                    <Form.Item
                        name="spApiClientId"
                        label={<span><LockOutlined /> SP API Client ID</span>}
                        rules={[{ required: true, message: 'Vui lòng nhập SP API Client ID' }]}
                    >
                        <Input.Password placeholder="Nhập SP API Client ID" />
                    </Form.Item>

                    <Form.Item
                        name="spApiClientSecret"
                        label={<span><LockOutlined /> SP API Client Secret</span>}
                        rules={[{ required: true, message: 'Vui lòng nhập SP API Client Secret' }]}
                    >
                        <Input.Password placeholder="Nhập SP API Client Secret" />
                    </Form.Item>

                    <Divider />
                    
                    <Alert
                        message="Lưu ý quan trọng"
                        description="Thiết lập SP API sẽ cập nhật thông tin trực tiếp trên worker đã chọn mà không cần phải khởi động lại. Các thay đổi này sẽ có hiệu lực ngay lập tức."
                        type="warning"
                        showIcon
                        style={{ marginBottom: 16 }}
                    />
                </Form>
            </Spin>
        </Modal>
    );
};

export default SpApiConfigurationModal;